/* eslint-disable camelcase */

/**
 * A Rate
 * @param {integer} id - Rate ID
 * @param {integer} event - event fk
 * @param {string} name - Name
 * @param {string} price - Price
 * @returns {Class} - Rate instance
**/

class Rate {
	constructor({
		id,
		event,
		name,
		price,
		description,
		group,
		display_order,
		created,
		category,
		inventories,
		contingents,
		translations,
		rate_template,
	} = {}){
		this._id = id;
		this._event = event;
		this._name = name;
		this._price = price;
		this._description = description;
		this._group = group;
		this._display_order = display_order;
		this._created = created;
		this._category = category;
		this._inventories = inventories;
		this._contingents = contingents;
		this._translations = translations;
		this._rate_template = rate_template;
	}

	getKey() {
		return String(this._id);
	}

	toString() {
		return this._name;
	}

	getEvent(){
		return this._event;
	}

	getName() {
		return this._name;
	}

	getPrice() {
		return this._price;
	}

	getDescription() {
		return this._description;
	}

	getGroup() {
		return this._group;
	}

	getDisplayOrder() {
		return this._display_order;
	}

	getCreated() {
		return this._created;
	}

	getCategory() {
		return this._category;
	}

	getInventories() {
		return this._inventories;
	}

	getContingents() {
		return this._contingents;
	}

	getTranslations() {
		return this._translations;
	}

	getTemplateName() {
		return this._name || this._rate_template?.name;
	}
}

export default Rate;
